import { render, staticRenderFns } from "./rightNotice.vue?vue&type=template&id=77aca078&scoped=true&"
import script from "./rightNotice.vue?vue&type=script&lang=js&"
export * from "./rightNotice.vue?vue&type=script&lang=js&"
import style0 from "./rightNotice.vue?vue&type=style&index=0&id=77aca078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aca078",
  null
  
)

export default component.exports